var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useStorage } from 'master-hook';
import { registerError } from '../use-app/actions';
import { STORAGE_NAME as authStorageName } from '../use-auth';
import { broadcastTokensUpdated } from '../use-auth/auth-tab-sync';
import { purge } from '../use-app/actions';
import { makeRequest } from './make-request';
import { client } from '../services';
/** Mutex: один relogin за раз, параллельные запросы ждут того же результата */
var reloginPromise = null;
var RELOGIN_COOLDOWN_MS = 60 * 1000;
var lastReloginAt = 0;
/**
 * Attempt to refresh tokens and repeat initial request.
 * Uses mutex to prevent race when multiple 401s trigger refresh in parallel.
 * @param options Initial HTTP request options
 * @returns `undefined` if error, response body if success
 */
export function refreshTokensAndRepeat(options) {
    return __awaiter(this, void 0, void 0, function () {
        function errorHandler(error, title, code) {
            var _a;
            registerError({
                code: code || ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status),
                title: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u044B\u0439 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440 \u043D\u0435 \u0441\u0440\u0430\u0431\u043E\u0442\u0430\u043B: ".concat(title || (error === null || error === void 0 ? void 0 : error.message)),
                text: error,
                more: options,
                source: 'iomart-hooks/utils/refresh-tokens-and-repeat',
            });
        }
        function doRelogin(refreshToken, setRefreshToken, setAccessToken) {
            return __awaiter(this, void 0, void 0, function () {
                var now, _a, access_token, refresh_token, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            now = Date.now();
                            if (lastReloginAt && now - lastReloginAt < RELOGIN_COOLDOWN_MS) {
                                errorHandler(null, 'Слишком частые запросы на обновление токена', 2429);
                                return [2 /*return*/, undefined];
                            }
                            lastReloginAt = now;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 5, , 6]);
                            return [4 /*yield*/, client.mutation({
                                    relogin: __assign(__assign({}, client.all), { __args: { refresh_token: refreshToken } }),
                                })];
                        case 2:
                            _a = (_c.sent()).relogin, access_token = _a.access_token, refresh_token = _a.refresh_token;
                            if (!access_token) {
                                purge();
                                errorHandler(null, "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D 'access_token'", 2401);
                                return [2 /*return*/, undefined];
                            }
                            return [4 /*yield*/, setRefreshToken(refresh_token)];
                        case 3:
                            _c.sent();
                            return [4 /*yield*/, setAccessToken(access_token)];
                        case 4:
                            _c.sent();
                            broadcastTokensUpdated(access_token, refresh_token);
                            return [2 /*return*/, { access_token: access_token }];
                        case 5:
                            _b = _c.sent();
                            purge();
                            return [2 /*return*/, undefined];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        }
        var _a, refreshToken, setRefreshToken, setAccessToken, result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = useStorage(authStorageName), refreshToken = _a.refreshToken, setRefreshToken = _a.setRefreshToken, setAccessToken = _a.setAccessToken;
                    if (!refreshToken) {
                        purge();
                        return [2 /*return*/, errorHandler(null, "\u041E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 'refresh_token'", 2401)];
                    }
                    if (!reloginPromise) {
                        reloginPromise = doRelogin(refreshToken, setRefreshToken, setAccessToken).finally(function () {
                            reloginPromise = null;
                        });
                    }
                    return [4 /*yield*/, reloginPromise];
                case 1:
                    result = _b.sent();
                    if (!(result === null || result === void 0 ? void 0 : result.access_token))
                        return [2 /*return*/, undefined];
                    return [2 /*return*/, makeRequest(options, result.access_token).catch(errorHandler)];
            }
        });
    });
}
